import { render, staticRenderFns } from "./rotarySowing.vue?vue&type=template&id=81158650"
import script from "./rotarySowing.vue?vue&type=script&lang=js"
export * from "./rotarySowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports